"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  main: 'Main',
  loading: 'loading...',
  ing: 'in the operation, please later...',
  number: 'index',
  tip: 'tip',
  createTime: 'create time',
  operation: 'operation',
  status: 'status',
  create: 'create',
  title: 'title',
  download: 'download',
  type: 'type',
  sort: 'sort',
  edit: 'edit',
  publish: 'publish',
  "delete": 'delete',
  draft: 'draft',
  cancel: 'cancel',
  confirm: 'ok',
  timestamp: 'timestamp',
  time: 'time',
  select: 'select',
  input: 'input',
  search1: 'search',
  describe: 'describe',
  require: 'is required',
  deleteMsg: '',
  pwd: 'password',
  rj: 'ruijie',
  coHost: 'Cloud Office Host',
  navbar: {
    chinese: 'Chinese',
    logout: 'logout',
    english: 'English',
    screenfull: '',
    user: '',
    language: '',
    welcome: 'Welcome,',
    customerService: 'Customer Service',
    initialConfig: 'Initial Config',
    alarm: 'Alarm',
    about: 'About'
  },
  login: {
    login: 'login',
    username: 'username',
    bbs: 'Community',
    contact: 'Online service',
    hotline: 'Technical service hotline',
    rj: 'Ruijie',
    wechat: 'WeChat',
    halo: 'Halo tool download',
    old: 'Old Client',
    oldtitle: 'download old client',
    oldwarm: 'Please click to download the old client.'
  },
  route: {
    cloudDesktop: 'Cloud Desktop',
    dashboard: 'Dashboard',
    documentation: 'Documentation',
    permission: 'Permission',
    icons: 'Icons',
    components: 'Components',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editor',
    dndList: 'Dnd List',
    splitPane: 'SplitPane',
    avatarUpload: 'Avatar Upload',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'CountTo',
    componentMixin: 'Mixin',
    backToTop: 'BackToTop',
    charts: 'Charts',
    keyboardChart: 'Keyboard Chart',
    lineChart: 'Line chart',
    mixChart: 'Mix Chart',
    example: 'Example',
    highConfig: 'Advanced Config',
    serverHostManage: 'Server Host Manage',
    serverHostUpgrade: 'host update',
    deployAndUpgrade: 'Deploy And Upgrade',
    Table: 'Table',
    dynamicTable: 'Dynamic Table',
    dragTable: 'Drag Table',
    inlineEditTable: 'Inline Edit',
    complexTable: 'Complex Table',
    tab: 'Tab',
    form: 'Form',
    createForm: 'Create Form',
    editForm: 'Edit Form',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    uploadExcel: 'Upload Excel',
    exportZip: 'Zip',
    theme: 'Theme',
    clipboardDemo: 'Clipboard',
    i18n: 'I18n',
    imageManage: 'Image Manage',
    userManage: 'User Manage',
    terminalManage: 'Terminal Manage',
    idvTerminalManage: 'IDV',
    vdiTerminalManage: 'VDI',
    terminalOsUpgrade: 'Client Upgrade',
    serverHostConfig: 'Server Host Config',
    cmsSunnyManage: 'CMS Sunny Manage',
    scheduleManage: 'Schedule Manage',
    logCollect: 'Data Collection',
    softPushInstall: 'push Install',
    license: 'License',
    oneKeyDeployLoginAuth: 'One Key Deploy Login Auth',
    ccrPackage: 'ccrpackage',
    authConfig: 'Auth',
    debugTools: 'Debugging Tool',
    otaServerManage: 'OTA Server Manage',
    storageManage: 'Storage Manage',
    USBManage: 'USB Manage',
    systemSetup: 'System Setup',
    networkConfig: 'Network Config',
    adminConfig: 'Adminstrator Config',
    changepwd: 'Password Settings',
    systemTime: 'System Time',
    loginTimeLimit: 'Login Time Limit',
    netDiskPortSetup: 'netDisk Port Setting',
    customerInfo: 'Customer Info',
    memoryInfo: 'Memory Info',
    haManager: 'HA',
    swimlane: 'swimlane',
    advancedConfig: 'Advanced Config',
    cloudDiskConfig: 'Cloud Disk Config'
  },
  complexTable: {
    importance: 'importance',
    author: 'author',
    auditor: 'auditor',
    pageviews: 'pageviews'
  },
  pushInstall: {
    fileList: 'File List',
    uploadOrDownload: 'Upload/Download',
    newTask: 'New Task',
    taskName: 'Task Name',
    creator: 'Creator',
    fileName: 'File Name',
    type: 'Type',
    startTime: 'Start Time',
    taskProgress: 'Task Progress',
    description: 'Description',
    operation: 'Operation',
    terminate: 'Terminate',
    uploadTime: 'Upload time',
    fileEdit: 'File Edit',
    fileSelection: 'File Selection',
    operationChoice: 'Operation Choice',
    timeSettings: 'Time Settings',
    terminalOption: 'Terminal Option',
    pushPath: 'Push Path',
    installPS: 'Install Parameter Setting',
    upload: 'Upload',
    uploadMsg: 'only single EXE, BET, MSI, MSU, and files are supported.'
  },
  dashboard: {
    alarm: 'alarm'
  },
  about: {
    version: 'version',
    hotline: 'Technical service hotline',
    bbs: 'Community',
    service: 'Technical service',
    supports: 'This system supports:Chrome, IE11, Firefox',
    resolution: 'The default support is 1024 x 768, and 1280*1024 resolution is recommended'
  },
  cloudDiskManage: 'Cloud Disk Manage',
  cloudDiskSync: {
    config: {
      title: 'Cloud Disk Config',
      serverIp: 'serverIp',
      httpPort: 'httpPort',
      httpsPort: 'httpsPort',
      docking: 'docking',
      dockingAndSync: 'docking And Sync',
      titleUsage: 'Usage：',
      descUsage: 'usage detail description',
      rules: {
        ip: 'input ip',
        port: 'ip port number'
      },
      syncTooltip: 'sync tip'
    },
    manage: {
      searchPlaceholder: 'administrator name',
      subManager: 'normal administrator',
      modifyConfig: 'modify config',
      chargeGroup: 'user group',
      operation: 'operation',
      syncLog: 'sync log',
      disablePrivilege: 'enable',
      enablePrivilege: 'disable',
      currentIp: 'current IP：'
    },
    syncLog: {
      reSync: 'reSync',
      syncTime: 'syncTime',
      syncContent: 'syncContent',
      syncResult: 'syncResult',
      failureReason: 'failureReason',
      to: 'to',
      success: 'success',
      failure: 'failure',
      searchStartTime: 'search start time',
      searchEndTime: 'search end time'
    }
  }
};
exports["default"] = _default;